var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#434656",
  d: "M10.001 12.292a.62.62 0 0 1-.442-.184L6.226 8.775a.625.625 0 0 1 .884-.884l2.892 2.891 2.892-2.891a.625.625 0 0 1 .884.884l-3.334 3.333a.63.63 0 0 1-.443.183"
})));
export default SvgArrowDown;